/**
 * Per-project callback tracking (localStorage).
 * A visitor may request one callback per project; other projects remain open.
 * Project key format MUST match backend phone_utils.build_project_key.
 */

const STORAGE_KEY = 'enquiry_projects_requested';

function normPart(value) {
    return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
}

/** Stable project identity for a property listing. */
export function projectKeyFromProperty(property) {
    if (!property || typeof property !== 'object') return '';
    const name = normPart(property.society_name || property.title || '');
    const city = normPart(property.city_slug || property.city || '');
    if (!name) return '';
    return `${name}|${city}`;
}

export function buildProjectKey({ societyName = '', title = '', city = '', citySlug = '', projectKey = '' } = {}) {
    if (projectKey && String(projectKey).trim()) return normPart(projectKey);
    const name = normPart(societyName || title);
    const cityPart = normPart(citySlug || city);
    if (!name) return '';
    return `${name}|${cityPart}`;
}

function readMap() {
    if (typeof window === 'undefined') return {};
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (_e) {
        return {};
    }
}

function writeMap(map) {
    if (typeof window === 'undefined') return;
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch (_e) { /* ignore quota */ }
}

export function hasRequestedProjectCallback(projectKey) {
    if (!projectKey) return false;
    const map = readMap();
    return Boolean(map[projectKey]);
}

export function markProjectCallbackRequested(projectKey, meta = {}) {
    if (!projectKey) return;
    const map = readMap();
    map[projectKey] = {
        at: Date.now(),
        ...meta,
    };
    writeMap(map);
}
